import { render, staticRenderFns } from "./CivilizationTile.vue?vue&type=template&id=10199314&scoped=true&"
import script from "./CivilizationTile.vue?vue&type=script&lang=js&"
export * from "./CivilizationTile.vue?vue&type=script&lang=js&"
import style0 from "./CivilizationTile.vue?vue&type=style&index=0&id=10199314&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10199314",
  null
  
)

export default component.exports